export enum PromoPopupContentTypeEnum {
  HeatDistribution = 'heatDistribution',
  DrinkingWaterInstallation = 'drinkingWaterInstallation',
  Sewage = 'sewage',
  Reguard = 'reguard',
  Resource = 'resource',
  TemperatureRegulator = 'temperatureRegulator',
}
